import React from 'react';
import SEO from '../SEO';
import styleClasses from '../css/mobile/AboutUs.module.scss';

const AboutUs = () => {
  return (
    <>
      <SEO title={'About Us'} />
      <div className={ styleClasses.aboutUs }>
        <div className={ styleClasses.inner }>
          <div className={ styleClasses.hero }>
            <h1 className={ styleClasses.title }>About Us</h1>
            <p className={ styleClasses.subtitle }>
              At Musizic, we believe in the power of music to bring people together. <br />Our platform is built for music enthusiasts, by music enthusiasts.
            </p>
          </div>
          <div className={ styleClasses.content }>
            <div className={ styleClasses.eachContent }>
              <h2 className={ styleClasses.title }>Our Mission</h2>
              <p className={ styleClasses.text }>
                To create a vibrant community where musicians and listeners can connect, share, and explore the beauty of music.
              </p>
            </div>
            <div className={ styleClasses.eachContent }>
              <h2 className={ styleClasses.title }>Our Team</h2>
              <p className={ styleClasses.text }>
                A group of passionate developers, designers, and music lovers dedicated to making music accessible and enjoyable for everyone.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutUs;
